import React from "react";
import WantedList from "components/backend/listings/wanted/index";

export default class WantedArchive extends React.Component {
  render() {
    return <WantedList status="archived" {...this.props} />;
  }
}
